import { apiRequest, HttpMethods } from "@alba-cars/common-modules";

export const notifyWebhookAboutUpdate = async (updatedData: Record<string, any>) => {
  const endpoint = `/sell-car-request/notify`;

  const response = await apiRequest<{ message: string }>(endpoint, {
    method: HttpMethods.POST,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updatedData),
  });
  return response;
};
